import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { boxShadowSelectionStyles, dangerBorderStyles, hideNativeBrowserTextSelectionStyles } from './selectionStyles';
export var DateSharedCssClassName = {
  DATE_WRAPPER: "date-lozenger-container",
  DATE_CONTAINER: 'dateView-content-wrap'
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var dateVanillaStyles = css(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "[data-prosemirror-node-name='date'] .".concat(DateSharedCssClassName.DATE_WRAPPER, " span"), {
  backgroundColor: "var(--ds-background-neutral, #0515240F)",
  color: "var(--ds-text, #292A2E)",
  borderRadius: "var(--ds-radius-small, 4px)",
  padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)"),
  margin: '0 1px',
  position: 'relative',
  transition: 'background 0.3s',
  whiteSpace: 'nowrap',
  cursor: 'unset'
}), "[data-prosemirror-node-name='date'] .".concat(DateSharedCssClassName.DATE_WRAPPER, " span:hover"), {
  backgroundColor: "var(--ds-background-neutral-hovered, #0B120E24)"
}), "[data-prosemirror-node-name='date'] .".concat(DateSharedCssClassName.DATE_WRAPPER, " span.date-node-color-red"), {
  backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
  color: "var(--ds-text-accent-red, #AE2E24)"
}), "[data-prosemirror-node-name='date'] .".concat(DateSharedCssClassName.DATE_WRAPPER, " span.date-node-color-red:hover"), {
  backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
}));

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var dateStyles = css(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(DateSharedCssClassName.DATE_WRAPPER, " span"), {
  whiteSpace: 'unset'
}), ".".concat(DateSharedCssClassName.DATE_CONTAINER), _defineProperty(_defineProperty({}, ".".concat(DateSharedCssClassName.DATE_WRAPPER), {
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 'initial',
  cursor: 'pointer'
}), '&.ak-editor-selected-node', _defineProperty({}, ".".concat(DateSharedCssClassName.DATE_WRAPPER, " > span"), [
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
boxShadowSelectionStyles,
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
hideNativeBrowserTextSelectionStyles]))), '.danger', _defineProperty({}, ".".concat(DateSharedCssClassName.DATE_CONTAINER, ".ak-editor-selected-node .").concat(DateSharedCssClassName.DATE_WRAPPER, " > span"), {
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)")
})));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var dangerDateStyles = css(_defineProperty({}, ".".concat(DateSharedCssClassName.DATE_CONTAINER, ".ak-editor-selected-node.danger .").concat(DateSharedCssClassName.DATE_WRAPPER, " > span"),
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
[dangerBorderStyles]));